import React, { memo } from 'react'
import { connect } from 'react-redux'
import { FeedbackMessage } from 'components/marketplace/FeedbackMessage'
import { Button } from 'transfix-ui/components/Button'
import { hideDeleteUserDialog, deleteUser, deleteParentUser } from 'utils/actions/user'
import { Dialog } from 'components/layout'

interface IDeleteUserDialogProps {
  showDeleteDialogForUserId: number
  deleting: boolean
  deleteError: string
  hideDeleteUserDialog: Function
  deleteParentUser: Function
}

const DeleteUserDialogComponent = memo<IDeleteUserDialogProps>(
  ({
    deleteError,
    deleteParentUser,
    deleting = false,
    hideDeleteUserDialog,
    showDeleteDialogForUserId,
  }) => {
    const deleteHandler = () => deleteParentUser(showDeleteDialogForUserId)
    const cancelHandler = () => hideDeleteUserDialog()
    return (
      <Dialog
        header='Are you sure?'
        size='small'
        closeDialog={hideDeleteUserDialog}
        dialogOpen={!!showDeleteDialogForUserId}
        footer={
          <div>
            <Button color='primary' disabled={deleting} onClick={deleteHandler}>
              Delete User
            </Button>
            <Button color='tertiary' disabled={deleting} onClick={cancelHandler}>
              Cancel
            </Button>
            {deleteError && <FeedbackMessage message={deleteError} type='error' />}
          </div>
        }
      />
    )
  }
)

export const DeleteUserDialog = connect(
  ({ userProfile: { deleteError, deleting, showDeleteDialogForUserId } }: any) => {
    return {
      showDeleteDialogForUserId,
      deleting,
      deleteError,
    }
  },
  { hideDeleteUserDialog, deleteUser, deleteParentUser }
)(DeleteUserDialogComponent)
